import {FormControl, InlineLink, Stack, Text} from '@primer/react-brand'

import type {GeneralConsentLanguageProps} from './types'
import {getAnalyticsEvent} from '../../../../../../lib/utils/analytics'
import {t} from '../../../../../../lib/utils/localization'

export default function China({fieldName, privacyStatementHref, children}: GeneralConsentLanguageProps) {
  return (
    <Stack direction="vertical" padding="none" gap="condensed">
      <FormControl>
        <FormControl.Label htmlFor={fieldName} data-testid="label">
          <Text weight="semibold">
            {t(
              'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the',
            )}{' '}
            <InlineLink
              {...getAnalyticsEvent({
                action: t('GitHub Privacy Statement'),
                tag: 'hyperlink',
                context: 'consent_language_china',
                location: 'form',
              })}
              href={privacyStatementHref}
            >
              {t('GitHub Privacy Statement')}
            </InlineLink>{' '}
            {t('for more details.')}
          </Text>
        </FormControl.Label>
        {children}
      </FormControl>

      <Text variant="muted">
        {t(
          'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.',
        )}
      </Text>
    </Stack>
  )
}
